import { node } from "~/util/dom";

export default class Subpage {
	_active: boolean;

	_container: HTMLDivElement;

	constructor() {
		this._active = false;
		this._container = node("div");
	}

	get node() {
		return this._container;
	}

	get active() {
		return this._active;
	}

	/* eslint-disable class-methods-use-this */
	activate() {
		/**/
	}

	deactivate() {
		/**/
	}
}
